var _style, _rect, _g, _g2, _g3, _g4, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoreDbVsWorkspaceDb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 450",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .bg { fill: #FFFFFF; }\n    .stroke-main { stroke: #111111; stroke-width: 2; fill: none; stroke-linecap: round; stroke-linejoin: round; }\n    .fill-main { fill: #111111; }\n    .text-main { font-family: system-ui, -apple-system, sans-serif; font-weight: 600; font-size: 14px; fill: #111111; text-anchor: middle; }\n    .text-sub { font-family: system-ui, -apple-system, sans-serif; font-weight: 500; font-size: 12px; fill: #111111; text-anchor: middle; }\n    \n    /* Animation: Central Pulse */\n    .pulse-ring {\n      transform-origin: 400px 110px;\n      animation: pulse 3s ease-in-out infinite;\n    }\n    @keyframes pulse {\n      0% { transform: scale(1); opacity: 0; }\n      50% { opacity: 0.25; }\n      100% { transform: scale(1.4); opacity: 0; }\n    }\n\n    /* Animation: Data Stream Flow */\n    .flow-line {\n      stroke: #111111;\n      stroke-width: 3;\n      stroke-dasharray: 6 18;\n      animation: flow 3s linear infinite;\n    }\n    @keyframes flow {\n      to { stroke-dashoffset: -48; }\n    }\n  ")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "bg",
    width: 800,
    height: 450
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "connections"
  }, /*#__PURE__*/React.createElement("line", {
    className: "stroke-main",
    x1: 400,
    y1: 110,
    x2: 200,
    y2: 280,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "stroke-main flow-line",
    x1: 400,
    y1: 110,
    x2: 200,
    y2: 280
  }), /*#__PURE__*/React.createElement("line", {
    className: "stroke-main",
    x1: 400,
    y1: 110,
    x2: 400,
    y2: 280,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "stroke-main flow-line",
    x1: 400,
    y1: 110,
    x2: 400,
    y2: 280
  }), /*#__PURE__*/React.createElement("line", {
    className: "stroke-main",
    x1: 400,
    y1: 110,
    x2: 600,
    y2: 280,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "stroke-main flow-line",
    x1: 400,
    y1: 110,
    x2: 600,
    y2: 280
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "core-db"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "fill-main pulse-ring",
    cx: 400,
    cy: 110,
    r: 40
  }), /*#__PURE__*/React.createElement("circle", {
    className: "bg",
    cx: 400,
    cy: 110,
    r: 40
  }), /*#__PURE__*/React.createElement("circle", {
    className: "stroke-main",
    cx: 400,
    cy: 110,
    r: 40,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    className: "stroke-main",
    d: "M380,100 C380,95 420,95 420,100 M380,100 C380,105 420,105 420,100 M380,107 C380,112 420,112 420,107 M380,114 C380,119 420,119 420,114 M380,100 L380,114 M420,100 L420,114"
  }), /*#__PURE__*/React.createElement("text", {
    className: "text-main",
    x: 400,
    y: 175
  }, "Core DB"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "workspace-a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "bg stroke-main",
    x: 130,
    y: 280,
    width: 140,
    height: 90,
    rx: 6,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    className: "text-sub",
    x: 200,
    y: 305
  }, "Workspace A"), /*#__PURE__*/React.createElement("line", {
    className: "stroke-main",
    x1: 150,
    y1: 325,
    x2: 250,
    y2: 325,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "stroke-main",
    x1: 150,
    y1: 337,
    x2: 230,
    y2: 337,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "stroke-main",
    x1: 150,
    y1: 349,
    x2: 240,
    y2: 349,
    opacity: 0.3
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "workspace-b"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "bg stroke-main",
    x: 330,
    y: 280,
    width: 140,
    height: 90,
    rx: 6,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    className: "text-sub",
    x: 400,
    y: 305
  }, "Workspace B"), /*#__PURE__*/React.createElement("line", {
    className: "stroke-main",
    x1: 350,
    y1: 325,
    x2: 450,
    y2: 325,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "stroke-main",
    x1: 350,
    y1: 337,
    x2: 430,
    y2: 337,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "stroke-main",
    x1: 350,
    y1: 349,
    x2: 440,
    y2: 349,
    opacity: 0.3
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "workspace-c"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "bg stroke-main",
    x: 530,
    y: 280,
    width: 140,
    height: 90,
    rx: 6,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    className: "text-sub",
    x: 600,
    y: 305
  }, "Workspace C"), /*#__PURE__*/React.createElement("line", {
    className: "stroke-main",
    x1: 550,
    y1: 325,
    x2: 650,
    y2: 325,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "stroke-main",
    x1: 550,
    y1: 337,
    x2: 630,
    y2: 337,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "stroke-main",
    x1: 550,
    y1: 349,
    x2: 640,
    y2: 349,
    opacity: 0.3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoreDbVsWorkspaceDb);
export default __webpack_public_path__ + "static/media/core-db-vs-workspace-db.7994586996949cef9f7795d197d27618.svg";
export { ForwardRef as ReactComponent };